import { forwardRef } from 'react';
import { Box } from '@mui/material';
import moment from "moment";
import Barcode from "react-barcode";
import { cashValueOfProduct, getChainName } from '../../lib';
import { formatPartiallyHiddenCpf, formatPoints } from "../../utils";

const contentSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0.5rem 0.3rem',
  fontSize: '1.4rem',
  border: '2px solid black',
  flexDirection: 'column',
  width: '10.13cm',
  backgroundColor: '#FFFFFF',
  fontFamily: 'Helvetica',
  fontWeight: 'bold',
  paddingBottom: '30px',
};

const barcodeSx = {
  width: '90%',
  margin: '0.6rem',
  display: 'flex',
  justifyContent: 'center',
};

const titleContainerSx = {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
};

const titleLeftSx = {
  textAlign: 'left',
  paddingTop: '2rem',
  fontWeight: 'bold',
  fontSize: '1.5rem',
  marginLeft: '30px',
};

const titleRightSx = {
  textAlign: 'right',
  paddingTop: '2rem',
  fontWeight: 'bold',
  fontSize: '1.5rem',
  marginRight: '30px',
};

const centeredMessageSx = {
  width: '80%',
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '1.2rem',
  fontSize: '1.2rem',
  textAlign: 'center',
};

const centeredInfoSx = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '0.6rem',
  fontSize: '1.7rem',
};

const adressSx = {
  width: '80%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: '0.8rem',
  fontSize: '0.8rem',
  textAlign: 'center',
};

const dateInfoSx = {
  width: '80%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: '0.8rem',
  fontSize: '0.9rem',
  textAlign: 'center',
};

const Coupon = forwardRef(({ coupon }, ref) => {
  if (coupon) {
    const price = formatPoints(coupon.value);
    const place = coupon.place;
    const address = place ? `${place.street}, ${place.streetNumber} - ${place.city}-${place.state}` : '';

    return (
      <Box ref={ref} sx={contentSx}>
        <Box sx={titleContainerSx}>
          <Box sx={titleLeftSx}>PontuaX</Box>
          <Box sx={titleRightSx}>{getChainName()}</Box>
        </Box>
        <Box sx={centeredMessageSx}>Produto Resgatado</Box>
        {/* Produto em dinheiro tem isCashback = true; por isso ele é testado ANTES do cashback livre. */}
        <Box sx={centeredInfoSx}>{coupon.product?.isCash ? `Voucher no valor de ${Number(cashValueOfProduct(coupon.product) ?? 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}` : coupon.isCashback ? `Cashback: ${Number(coupon.partnerValue).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}` : coupon.title || coupon.product?.name }</Box>
        <Box sx={{ ...centeredInfoSx, fontSize: '1.2rem', width: '90%' }}>{coupon.product ? coupon.product.description : coupon.description}</Box>
        <Box sx={centeredInfoSx}>{coupon.isGift ? 'Recompensa' : `${price} pontos`}</Box>
        <Box sx={barcodeSx}>
          <Barcode value={coupon.barcode} fontSize={18} width={2} />
        </Box>
        {coupon.customer.name &&
          <Box sx={centeredMessageSx}>Nome do cliente: {coupon.customer.name}</Box>
        }
        {coupon.customer.cpf &&
          <Box sx={centeredMessageSx}>CPF do cliente: {formatPartiallyHiddenCpf(coupon.customer.cpf)}</Box>
        }
        <Box sx={centeredMessageSx}>{coupon.place ? `Local de troca: ${place.name}` : ''}</Box>
        <Box sx={adressSx}>{coupon.place ? `${address}` : ''}</Box>
        {/* Duas datas distintas: `createdAt` é quando o cliente trocou os pontos pelo cupom,
            `redeemedAt` é quando o cupom foi validado no balcão. O comprovante impresso aqui
            sai na validação, então costuma trazer as duas. */}
        <Box sx={dateInfoSx}>Resgatado em: {moment(coupon.createdAt || new Date()).format('DD/MM/YYYY - HH:mm')}</Box>
        {
          coupon.redeemedAt &&
          <Box sx={dateInfoSx}>Validado em: {moment(coupon.redeemedAt).format('DD/MM/YYYY - HH:mm')}</Box>
        }
      </Box>
    );
  } else {
    return null;
  }
});

export default Coupon;
